import newApi from '../api/new-api';

const search = async (condition, pagination) => {
	try {
		const result = await newApi.search(condition, pagination);
		return { list: result.list, pagination: result.paginable };
	} catch (err) {
		console.error(err);
		throw err;
	}
};

const getById = async (payload) => {
    const resp = await newApi.getById(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const add = async (news) => {
    const resp = await newApi.add(news);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const edit = async (news) => {
    const resp = await newApi.edit(news);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const remove = async (news) => {
    const resp = await newApi.remove(news);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const newService = {
    search,
    getById,
    add,
    edit,
    remove
};

export default newService;